/**
 *
 */
export default class ACFFlexibleContentLayoutLoader
{
	/**
	 *
	 */
	public layoutLoaders: {};


	/**
	 *
	 * @param {{
	 * 		layoutLoaders: {}
	 * }} params
	 */
	public constructor( params: { layoutLoaders: {} } )
	{
		this.layoutLoaders = params.layoutLoaders || {};
	}


	// noinspection JSUnusedGlobalSymbols
	/**
	 *
	 * @param {string} name
	 */
	public loadSection( name: string )
	{
		const sectionLoaderName = Object.keys( this.layoutLoaders ).find( sectionName => sectionName === name );

		if (sectionLoaderName) {
			this.layoutLoaders[sectionLoaderName]();
		}
	}


	/**
	 *
	 */
	public loadAll()
	{
		Object.keys( this.layoutLoaders ).forEach( sectionLoaderName =>
		{
			this.layoutLoaders[sectionLoaderName]();
		} );
	}
}
